<div class="device-picker">
  <div class="device-picker__header">
    <i class="material-icons device-picker__icon">print</i>
    <h2 class="device-picker__title" mat-dialog-title>{{ title }}</h2>
  </div>

  <mat-dialog-content class="device-picker__content">
    <div class="device-picker__empty" *ngIf="!devices?.length">
      <i class="material-icons">info</i>
      <span>{{ emptyMessage }}</span>
    </div>

    <button class="device-picker__row"
            *ngFor="let d of devices"
            (click)="pick(d)"
            type="button"
            data-testid="device-picker-row">
      <i class="material-icons device-picker__row-icon">point_of_sale</i>
      <span class="device-picker__row-name">{{ d.name || ('Device ' + d.id) }}</span>
      <span class="device-picker__row-meta" *ngIf="describe(d)">{{ describe(d) }}</span>
      <i class="material-icons device-picker__row-arrow">chevron_right</i>
    </button>
  </mat-dialog-content>

  <div class="device-picker__actions">
    <button class="device-picker__btn device-picker__btn--cancel" (click)="cancel()" type="button">
      Cancel
    </button>
  </div>
</div>
